// formDataConfig.js

// Initial state for building form data
export const initialBuildingFormData = {
  buildingSite: '',
  buildingID: '',
  customerID: '',
  customerName: '',
  agencyID: '',
  agencyName: '',
  buildingBalance: '',
  buildingReference: '',
  buildingNote: '',
  buildingAdded: '',
  addressID: '',
  location: '',
  state: '',
  zip: '',
  salesRep: '',
  buildingStatus: '',
  buildingType: '',
  dispatchType: '',
  routeID: '',
  taxID: '',
  billingClass: '',
  mainPhone: '',
  contactName: '',
  email: '',
  contacts: [],
  mainContactID: '',
  agentID: '',
  superintendentID: '',
  collectionsID: '',
  dobContactID: '',
  buildingReferenceSite: '',        // Added field
  managementCompanyName: '',       // Added field
};

// Mappings and options

// Building Statuses
export const BuildingStatuses = [

  { key: 'Active', label: 'Active' },
  { key: 'Inactive', label: 'Inactive' },
  { key: 'Pending', label: 'Pending' },
  { key: 'Cancelled', label: 'Cancelled' },
  { key: 'Collection', label: 'Collection' },
  { key: 'Transferred', label: 'Transferred' },
  { key: 'Expired', label: 'Expired' },
];

// Building Statuses Mapping
export const BuildingStatusesMapping = BuildingStatuses.reduce((acc, { key, label }) => {
  acc[key] = label;
  return acc;
}, {});

// Billing Class Options
export const BillingClassOptions = [
  { key: 'ARCTEC', label: 'ARCTEC ELEVATOR' },
  { key: 'CHAMP_NJ', label: 'Champion - NJ' },
  { key: 'CHAMPION', label: 'Champion Elevator Accounts' },
  { key: 'ECLIPSE', label: 'Eclipse Elevator' },
  { key: 'GENCO', label: 'Genco Elevator' },
  { key: 'HUNTER', label: 'Hunter Elevator' },
  { key: 'INDEPENDENCE', label: 'Independence Elevator' },
  { key: 'INFINITY', label: 'Infinity Elevator' },
  { key: 'NESCO', label: 'North Eastern Elevator Service' },
  { key: 'PAYTON', label: 'Payton Elevator' },
  { key: 'PRO', label: 'Pro Elevator' },
  { key: 'SUPERIOR', label: 'Superior Elevator' },
  { key: 'WESTECH', label: 'Original Westech Accounts' },
];

// Building Types
export const BuildingTypes = [
  { key: 'Commercial', label: 'Commercial' },
  { key: 'Company/Office', label: 'Company/Office' },
  { key: 'Garage', label: 'Garage' },
  { key: 'Government', label: 'Government' },
  { key: 'Hospital', label: 'Hospital' },
  { key: 'Nursing Home', label: 'Nursing Home' },
  { key: 'Other', label: 'Other' },
  { key: 'Parent Location', label: 'Parent Location' },
  { key: 'Religious Facility', label: 'Religious Facility' },
  { key: 'Residential', label: 'Residential' },
  { key: 'Restaurant', label: 'Restaurant' },
  { key: 'School', label: 'School' },
  { key: 'Ship', label: 'Ship' },
  { key: 'Transportation Facility', label: 'Transportation Facility' },
];

// Building Types Mapping
export const BuildingTypesMapping = BuildingTypes.reduce((acc, { key, label }) => {
  acc[key] = label;
  return acc;
}, {});

// Dispatch Types
export const DispatchTypes = [

  { key: 'Standard', label: 'Standard' },
  { key: 'Priority', label: 'Priority' },
  { key: 'Emergency', label: 'Emergency' },
];

export const DispatchTypesMapping = {
  Standard: 'Standard',
  Priority: 'Priority',
  Emergency: 'Emergency',

};

// Status Options
export const StatusOptions = [
  { key: 'Active', label: 'Active' },
  { key: 'Inactive', label: 'Inactive' },
  { key: 'Pending', label: 'Pending' },
];

// Field definitions

// Building Fields
export const BuildingFields = [
  { key: 'buildingReference', label: 'Building Reference' },
  { key: 'location', label: 'Building Name' },
  { key: 'companyName', label: 'Company Name', readOnly: true },

];


// Sales Maintenance Fields
export const SalesMaintenanceFields = [
  { key: 'salesIndexMaintenance', label: 'Maintenance Index' },
  { key: 'salesIndexParts', label: 'Parts Index' },
  { key: 'salesIndexProposal', label: 'Proposal Index' },
  { key: 'salesIndexService', label: 'Service Index' },
];

// Additional Info Fields
export const AdditionalInfoFields = [
  { key: 'taxDetailID', label: 'Tax ID' },
  { key: 'territory', label: 'Territory' },
  { key: 'superintendentID', label: 'Superintendent ID' },
  { key: 'collectionsID', label: 'Collections ID' },
];

// Balance Fields
export const BalanceFields = [
  { key: 'buildingBalance', label: 'Building Balance', type: 'currency' },
  { key: 'buildingMonthlyBalance', label: 'Monthly Balance', type: 'currency' },
  { key: 'buildingYearlyBalance', label: 'Yearly Balance', type: 'currency' },
];

// Address Fields
export const AddressFields = [
  { key: 'addressCareOf', label: 'Care Of' },
  { key: 'addressLine1', label: 'Street' },
  { key: 'addressLine2', label: 'Street 2' },
  { key: 'city', label: 'City' },
  { key: 'state', label: 'State' },
  { key: 'zip', label: 'Zip Code' },
];

// Billing Address Fields
export const BillingAddressFields = [
  { key: 'billingAddressCareOf', label: 'Care Of' },
  { key: 'billingAddressLine1', label: 'Street' },
  { key: 'billingAddressLine2', label: 'Street 2' },
  { key: 'billingCity', label: 'City' },
  { key: 'billingState', label: 'State' },
  { key: 'billingZip', label: 'Zip Code' },
];




// Building Status Fields
export const BuildingStatusFields = [
  { key: 'buildingStatus', label: 'Building Status' },
  { key: 'routeID', label: 'Route ID' },
  { key: 'taxDetailID', label: 'Tax ID' },
  { key: 'agencyID', label: 'Agency ID' },
];

// Route Fields
export const RouteFields = [
  { key: 'routeID', label: 'Route ID', type: 'text' },
  { key: 'routeDescription', label: 'Route Description', type: 'text' },
  { key: 'active', label: 'Active', type: 'checkbox' },
  { key: 'routeType', label: 'Route Type', type: 'text' },
  { key: 'employeeID', label: 'Employee ID', type: 'text' },
  { key: 'mechanic', label: 'Mechanic', type: 'text' },
  { key: 'managerID', label: 'Manager ID', type: 'text' },
  { key: 'supervisorID', label: 'Supervisor ID', type: 'text' },
  { key: 'location', label: 'Location', type: 'text' },
  { key: 'territory', label: 'Territory', type: 'text' },
];

// Contact Fields
export const ContactFields = [
  {
    key: 'mainContact',
    label: 'Main Contact',
    fields: [
      { key: 'contactName', label: 'Name' },
      { key: 'mainPhone', label: 'Phone' },
      { key: 'cellPhone', label: 'Cell Phone' },
      { key: 'emailAddress', label: 'Email' },
    ],
  },
  {
    key: 'agent',
    label: 'Agent',
    fields: [
      { key: 'agentName', label: 'Name' },
      { key: 'agentPhone', label: 'Phone' },
      { key: 'agentCellPhone', label: 'Cell Phone' },
      { key: 'agentEmail', label: 'Email' },
    ],
  },
  {
    key: 'superintendent',
    label: 'Superintendent',
    fields: [
      { key: 'superName', label: 'Name' },
      { key: 'superPhone', label: 'Phone' },
      { key: 'superCellPhone', label: 'Cell Phone' },
      { key: 'superEmail', label: 'Email' },
    ],
  },
  {
    key: 'collections',
    label: 'Collections',
    fields: [
      { key: 'collectionsName', label: 'Name' },
      { key: 'collectionsPhone', label: 'Phone' },
      { key: 'collectionsCellPhone', label: 'Cell Phone' },
      { key: 'collectionsEmail', label: 'Email' },
    ],
  },
  {
    key: 'dobContact',
    label: 'DOB Contact',
    fields: [
      { key: 'dobName', label: 'Name' },
      { key: 'dobPhone', label: 'Phone' },
      { key: 'dobCellPhone', label: 'Cell Phone' },
      { key: 'dobEmail', label: 'Email' },
    ],
  },
];

// Contact Titles
export const ContactTitles = [
  { key: 'mainContact', label: 'Main Contact' },
  { key: 'agentContact', label: 'Agent Contact' },
  { key: 'superintendentContact', label: 'Superintendent Contact' },
  { key: 'collectionsContact', label: 'Collections Contact' },
  { key: 'dobContact', label: 'DOB Contact' },
];